module.exports = __webpack_public_path__ + "media/packs/images/flags/PH-c3502088a303027c57202360e08c8733.svg";